import { Code, type CodeProps, Spinner } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';

import { apiInfoClient } from '~sf/api/clients';
import { QueryKey } from '~sf/api/query';
import { importMetaEnv } from '~sf/constants';

export const releaseVersion = importMetaEnv.VITE_RELEASE_VERSION || '-';

type AppVersionProps = CodeProps;

const AppVersion = ({ ...rest }: AppVersionProps) => {
  const { isLoading } = useQuery({
    queryKey: QueryKey.ApiInfo,
    queryFn: async () => apiInfoClient({}),
  });

  if (isLoading) {
    return <Spinner size="sm" />;
  }

  return <Code {...rest}>{releaseVersion}</Code>;
};

export default AppVersion;
